import { debounce } from 'lodash';
import { tns } from 'tiny-slider/src/tiny-slider';

class Carousels {
  constructor() {
    // Elements
    this.carouselElements = document.querySelectorAll('[data-carousel]');
    this.carouselGalleryElements = document.querySelectorAll(
      '[data-gallery-carousel]'
    );
    this.cardCarouselElements = document.querySelectorAll(
      '[data-card-carousel]'
    );

    // Controls markup
    this.controlsMarkup = [
      '<i class="fas fa-chevron-left fa-3x"></i><span class="visually-hidden">Prev</span>',
      '<i class="fas fa-chevron-right fa-3x"></i><span class="visually-hidden">Next</span>',
    ];

    // Init
    this.carouselsInit();
    this.carouselsGalleryInit();
    this.cardCarouselsInit();
  }

  cardCarouselsInit() {
    if (this.cardCarouselElements) {
      this.cardCarouselElements.forEach((cardCarouselElement) => {
        // Data attr options
        const options = {
          desktopSlideCount: cardCarouselElement.dataset.cardCarouselCount || 3,
          noLoop: cardCarouselElement.hasAttribute(
            'data-card-carousel-no-loop'
          ),
        };
        tns({
          mode: 'carousel',
          container: cardCarouselElement,
          navPosition: 'bottom',
          controls: false,
          controlsText: this.controlsMarkup,
          autoplay: false,
          autoplayHoverPause: true,
          autoplayButtonOutput: false,
          loop: !options.noLoop,
          items: 1,
          edgePadding: 32,
          gutter: 16,
          responsive: {
            // Bootstrap small breakpoint
            576: {
              items: 2,
            },
            // Bootstrap medium breakpoint
            768: {
              items: options.desktopSlideCount,
            },
            1240: {
              controls: true,
            },
          },
        });
      });
    }
  }

  carouselsGalleryInit() {
    if (this.carouselGalleryElements) {
      this.carouselGalleryElements.forEach((carouselGalleryElement) => {
        // Data attr options
        const options = {
          hideMobileControls: !carouselGalleryElement.hasAttribute(
            'data-carousel-hide-mobile-controls'
          ),
          autoPlay: carouselGalleryElement.hasAttribute(
            'data-carousel-autoplay'
          ),
          autoHeight: carouselGalleryElement.hasAttribute(
            'data-carousel-autoheight'
          ),
        };

        tns({
          container: carouselGalleryElement,
          mode: 'gallery',
          autoplay: options.autoPlay,
          autoHeight: options.autoHeight,
          speed: 500,
          autoplayHoverPause: true,
          autoplayButtonOutput: false,
          controls: options.hideMobileControls,
          controlsText: this.controlsMarkup,
          onInit: () => {
            if (carouselGalleryElement.querySelector('.image__caption')) {
              // Position the nav from the top of the carousels picture element so we can place caption below each slide, element must have a caption
              this.positionNavInit(carouselGalleryElement);

              // Position the prev/next controls 50% image height if captions are present
              this.positionControlsInit(carouselGalleryElement);
            }
          },
        });
      });
    }
  }

  carouselsInit() {
    if (this.carouselElements) {
      this.carouselElements.forEach((carouselElement) => {
        // Data attr options
        const options = {
          hideMobileControls: !carouselElement.hasAttribute(
            'data-carousel-hide-mobile-controls'
          ),
          autoPlay: carouselElement.hasAttribute('data-carousel-autoplay'),
          autoHeight: carouselElement.hasAttribute('data-carousel-autoheight'),
        };

        tns({
          container: carouselElement,
          mode: 'carousel',
          autoplay: options.autoPlay,
          controls: options.hideMobileControls,
          autoHeight: options.autoHeight,
          speed: 500,
          center: true,
          gutter: 16,
          items: 1,
          loop: true,
          edgePadding: 0,
          autoplayHoverPause: true,
          autoplayButtonOutput: false,
          controlsText: [
            '<i class="fas fa-chevron-left fa-2x"></i><span class="visually-hidden">Prev</span>',
            '<i class="fas fa-chevron-right fa-2x"></i><span class="visually-hidden">Next</span>',
          ],
          onInit: () => {
            if (carouselElement.querySelector('.image__caption')) {
              // Position the nav from the top of the carousels picture element so we can place caption below each slide, element must have a caption
              this.positionNavInit(carouselElement);

              // Position the prev/next controls 50% image height if captions are present
              this.positionControlsInit(carouselElement);
            }
          },
          responsive: {
            576: {
              edgePadding: 40,
            },
            768: {
              edgePadding: 80,
            },
            1400: {
              controls: true,
            },
          },
        });
      });
    }
  }

  positionNavInit(carousel) {
    this.positionNav(carousel);
    window.addEventListener(
      'resize',
      debounce(() => {
        this.positionNav(carousel);
      }, 100)
    );
  }

  positionNav(carousel) {
    const image = carousel.querySelector('picture');
    const nav = carousel
      .closest('.carousel__wrapper')
      .querySelector('.tns-nav');
    const offset = image.offsetHeight - nav.offsetHeight - 24;
    nav.style.top = `${offset}px`;
    nav.style.bottom = 'auto';
  }

  positionControlsInit(carousel) {
    this.positionControls(carousel);
    window.addEventListener(
      'resize',
      debounce(() => {
        this.positionControls(carousel);
      }, 100)
    );
  }

  positionControls(carousel) {
    const image = carousel.querySelector('picture');
    const controls = carousel
      .closest('.carousel__wrapper')
      .querySelector('.tns-controls');
    const offset = image.offsetHeight / 2;
    controls.style.top = `${offset}px`;
  }
}

// Sometimes the content could be react component. But tns requires content to be static.
// So need to hold the initializaiton until react comp mounted.
function loop() {
  if (window.ecom.need_wait_react_mounted) {
    window.requestAnimationFrame(loop);
  } else {
    new Carousels();
  }
}

document.addEventListener('DOMContentLoaded', loop);
